// export function globalScripts(): void {
//   console.log('silence is golden');
// }
import * as jQuery from 'jquery';
var $ = jQuery;
export function globalScripts() {
    // Fade-in-up animation utility
    function initFadeInUpAnimations() {
        // Check if we're in Elementor editor - multiple detection methods
        var isElementorEditor = document.body.classList.contains('elementor-editor-active') ||
            document.body.classList.contains('elementor-editor') ||
            document.querySelector('.elementor-editor') ||
            window.location.search.includes('action=elementor') ||
            typeof window.elementorFrontend !== 'undefined' && window.elementorFrontend.isEditMode();
        // If in Elementor editor, show all elements immediately and don't apply CSS
        if (isElementorEditor) {
            document.querySelectorAll('.fade-in-up').forEach(function (element) {
                element.classList.add('fade-in-up--visible');
                // Also remove the fade-in-up class to prevent CSS from applying
                element.classList.remove('fade-in-up');
            });
            return;
        }
        var fadeInElements = document.querySelectorAll('.fade-in-up');
        if (fadeInElements.length === 0)
            return;
        // Create Intersection Observer for scroll detection
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var element_1 = entry.target;
                    // Check if this element is part of a group of siblings
                    var parent_1 = element_1.parentElement;
                    if (parent_1) {
                        var siblings = Array.from(parent_1.querySelectorAll('.fade-in-up'));
                        var index = siblings.indexOf(element_1);
                        // Add staggered delay based on sibling position + 500ms initial delay
                        var delay = 250 + (index * 150);
                        setTimeout(function () {
                            element_1.classList.add('fade-in-up--visible');
                        }, delay);
                    }
                    else {
                        // No siblings, animate after 250ms initial delay
                        setTimeout(function () {
                            element_1.classList.add('fade-in-up--visible');
                        }, 250);
                    }
                    // Stop observing this element
                    observer.unobserve(element_1);
                }
            });
        }, {
            threshold: 0.1, // Trigger when 10% of element is visible
            rootMargin: '0px 0px -50px 0px' // Start animation slightly before element is fully in view
        });
        // Observe all fade-in-up elements
        fadeInElements.forEach(function (element) {
            observer.observe(element);
        });
    }
    // Initialize fade-in-up animations
    initFadeInUpAnimations();
    // Re-initialize after Elementor frontend is ready (for dynamic content)
    if (typeof window.elementorFrontend !== 'undefined' && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', function () {
            setTimeout(initFadeInUpAnimations, 100);
        });
    }
    // Desktop Navigation Menu Functionality
    // Handles click-based submenu toggles and outside click detection
    var header = document.querySelector('.desktop-header');
    if (header) {
        // Get all menu items with children
        var menuItemsWithChildren_1 = header.querySelectorAll('.has-children');
        // Add click event listeners to menu items with children
        menuItemsWithChildren_1.forEach(function (item) {
            var menuLink = item.querySelector('.menu-link');
            var menuIndicator = item.querySelector('.menu-indicator');
            if (menuLink && menuIndicator) {
                menuLink.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    // Close all other open menus first
                    menuItemsWithChildren_1.forEach(function (otherItem) {
                        if (otherItem !== item && otherItem.classList.contains('open')) {
                            otherItem.classList.remove('open');
                            var otherIndicator = otherItem.querySelector('.menu-indicator');
                            if (otherIndicator) {
                                otherIndicator.textContent = '+';
                            }
                        }
                    });
                    // Toggle current menu
                    var isOpen = item.classList.contains('open');
                    if (isOpen) {
                        // Close menu
                        item.classList.remove('open');
                        menuIndicator.textContent = '+';
                    }
                    else {
                        // Open menu
                        item.classList.add('open');
                        menuIndicator.textContent = '—';
                    }
                });
            }
        });
        // Close menus when clicking outside
        document.addEventListener('click', function (e) {
            if (!header.contains(e.target)) {
                menuItemsWithChildren_1.forEach(function (item) {
                    if (item.classList.contains('open')) {
                        item.classList.remove('open');
                        var indicator = item.querySelector('.menu-indicator');
                        if (indicator) {
                            indicator.textContent = '+';
                        }
                    }
                });
            }
        });
        // Close menus when pressing Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                menuItemsWithChildren_1.forEach(function (item) {
                    if (item.classList.contains('open')) {
                        item.classList.remove('open');
                        var indicator = item.querySelector('.menu-indicator');
                        if (indicator) {
                            indicator.textContent = '+';
                        }
                    }
                });
            }
        });
    }
    // Mobile Navigation Menu Functionality
    var mobileHeader = document.querySelector('.mobile-header');
    if (mobileHeader) {
        var mobileMenuToggle_1 = mobileHeader.querySelector('.mobile-menu-toggle');
        var mobileNav_1 = mobileHeader.querySelector('.mobile-nav');
        var mobileMenuItems_1 = mobileHeader.querySelectorAll('.menu-item.menu-item-has-children');
        // Toggle mobile menu
        if (mobileMenuToggle_1 && mobileNav_1) {
            mobileMenuToggle_1.addEventListener('click', function () {
                var isOpen = mobileNav_1.classList.contains('open');
                if (isOpen) {
                    // Close mobile menu
                    mobileNav_1.classList.remove('open');
                    mobileMenuToggle_1.classList.remove('open');
                    // Close all submenus
                    mobileMenuItems_1.forEach(function (item) {
                        item.classList.remove('open');
                    });
                }
                else {
                    // Open mobile menu
                    mobileNav_1.classList.add('open');
                    mobileMenuToggle_1.classList.add('open');
                }
            });
        }
        // Handle mobile submenu toggles (accordion effect)
        mobileMenuItems_1.forEach(function (item) {
            var menuLink = item.querySelector('a');
            var indicator = item.querySelector('.menu-indicator');
            if (menuLink && indicator) {
                menuLink.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    // Close all other open submenus first
                    mobileMenuItems_1.forEach(function (otherItem) {
                        if (otherItem !== item && otherItem.classList.contains('open')) {
                            otherItem.classList.remove('open');
                        }
                    });
                    // Toggle current submenu
                    var isOpen = item.classList.contains('open');
                    if (isOpen) {
                        // Close submenu
                        item.classList.remove('open');
                        indicator.textContent = '+';
                    }
                    else {
                        // Open submenu
                        item.classList.add('open');
                        indicator.textContent = '—';
                    }
                });
            }
        });
        // Close mobile menu when clicking outside
        document.addEventListener('click', function (e) {
            if (!mobileHeader.contains(e.target)) {
                mobileNav_1 === null || mobileNav_1 === void 0 ? void 0 : mobileNav_1.classList.remove('open');
                mobileMenuToggle_1 === null || mobileMenuToggle_1 === void 0 ? void 0 : mobileMenuToggle_1.classList.remove('open');
                // Close all submenus
                mobileMenuItems_1.forEach(function (item) {
                    item.classList.remove('open');
                });
            }
        });
        // Close mobile menu when pressing Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                mobileNav_1 === null || mobileNav_1 === void 0 ? void 0 : mobileNav_1.classList.remove('open');
                mobileMenuToggle_1 === null || mobileMenuToggle_1 === void 0 ? void 0 : mobileMenuToggle_1.classList.remove('open');
                // Close all submenus
                mobileMenuItems_1.forEach(function (item) {
                    item.classList.remove('open');
                });
            }
        });
    }
    // Dynamic Header Positioning for Wide Screens
    function initDynamicHeaderPositioning() {
        var desktopHeader = document.querySelector('.desktop-header');
        if (!desktopHeader)
            return;
        function calculateHeaderPosition() {
            // Only apply dynamic positioning for screens 1441px and wider
            if (window.innerWidth < 1441)
                return;
            // Find the main content container - look for .e-con-inner elements
            // These are the actual content containers that house the widgets
            var contentSelectors = [
                '.e-con-inner',
                '.elementor-section .e-con-inner',
                '.elementor-container .e-con-inner',
                '.elementor-section.elementor-section-boxed .elementor-container .e-con-inner',
                '.elementor-container.elementor-container-boxed .e-con-inner'
            ];
            var contentContainer = null;
            // First, try to find .e-con-inner containers with constrained width (not full-width)
            for (var _i = 0, contentSelectors_1 = contentSelectors; _i < contentSelectors_1.length; _i++) {
                var selector = contentSelectors_1[_i];
                var containers = document.querySelectorAll(selector);
                for (var i = 0; i < containers.length; i++) {
                    var container = containers[i];
                    var rect = container.getBoundingClientRect();
                    // Look for containers that are centered and have reasonable width (not full viewport)
                    if (rect.width > 500 && rect.width < 1500 && rect.left > 0) {
                        contentContainer = container;
                        break;
                    }
                }
                if (contentContainer)
                    break;
            }
            // If no constrained container found, try the first available .e-con-inner
            if (!contentContainer) {
                for (var _a = 0, contentSelectors_2 = contentSelectors; _a < contentSelectors_2.length; _a++) {
                    var selector = contentSelectors_2[_a];
                    contentContainer = document.querySelector(selector);
                    if (contentContainer)
                        break;
                }
            }
            // If no specific container found, use the body as fallback
            if (!contentContainer) {
                contentContainer = document.body;
            }
            // Get the container's position and dimensions
            var containerRect = contentContainer.getBoundingClientRect();
            var containerLeft = containerRect.left;
            // Calculate the dynamic left position
            // This should be: container left edge - header width (223px) + some padding - 70px offset
            var headerWidth = 223; // Width of the header
            var padding = 20; // Desired padding from container edge
            var offset = 70; // Additional offset to prevent overlapping
            var dynamicLeft = Math.max(20, containerLeft - headerWidth + padding - offset);
            // Apply the calculated position
            desktopHeader.style.setProperty('--header-dynamic-left', "".concat(dynamicLeft, "px"));
        }
        // Calculate position on load
        calculateHeaderPosition();
        // Recalculate on window resize (with debouncing)
        var resizeTimeout;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(calculateHeaderPosition, 100);
        });
        // Recalculate when Elementor content changes (for dynamic content)
        if (typeof window.elementorFrontend !== 'undefined' && window.elementorFrontend.hooks) {
            window.elementorFrontend.hooks.addAction('frontend/element_ready/global', function () {
                setTimeout(calculateHeaderPosition, 100);
            });
        }
    }
    // Initialize dynamic header positioning
    initDynamicHeaderPositioning();
}
